import React, { Component } from "react";
import { Col, Row, Container, Media, Collapse } from "reactstrap";
import { joinCss } from "../../helpers/utils";
import { getFileLinkWithPage } from "../../helpers/utils";

import closeCircle from "../../images/closeCircle.png";

import appClasses from "../../App.module.scss";
import classes from "./MoreResults.module.scss";

class MoreResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false
    };
  }

  render() {
    return (
      <Collapse isOpen={this.props.isOpen}>
        <Container>
          <Row>
            <Col md="1">
              <Media
                src={closeCircle}
                alt="סגור"
                onClick={() => this.props.closeHeandler()}
              />
            </Col>
            <Col md="11">
              {this.props.list.map((data, index) => {
                return index === 0 ? (
                  ""
                ) : (
                  <a
                    key={index}
                    className={appClasses.resultContantLink}
                    target="_blank"
                    href={getFileLinkWithPage(
                      this.props.result.hit.docIdentity,
                      this.props.result.hit.pdfName,
                      this.props.result.hit.page
                    )}
                  >
                    <Row
                      key={this.props.index}
                      className={joinCss(
                        appClasses.resultLineMin,
                        "mb-4",
                        appClasses["vertical-center-parent"]
                      )}
                    >
                      <Col className={joinCss(classes.resultTextMin, "my-3")}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data
                          }}
                        />
                      </Col>
                    </Row>
                  </a>
                );
              })}
            </Col>
          </Row>
        </Container>
      </Collapse>
    );
  }
}

export default MoreResults;
